import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDeals } from 'app/entities/deal/deal.reducer';
import { getEntities as getUserCashBacks } from 'app/entities/user-cash-back/user-cash-back.reducer';
import { createEntity, getEntity, reset, updateEntity } from './user-cash-back-deal.reducer';

export const UserCashBackDealUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const deals = useAppSelector(state => state.deal.entities);
  const userCashBacks = useAppSelector(state => state.userCashBack.entities);
  const userCashBackDealEntity = useAppSelector(state => state.userCashBackDeal.entity);
  const loading = useAppSelector(state => state.userCashBackDeal.loading);
  const updating = useAppSelector(state => state.userCashBackDeal.updating);
  const updateSuccess = useAppSelector(state => state.userCashBackDeal.updateSuccess);

  const handleClose = () => {
    navigate(`/user-cash-back-deal${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDeals({}));
    dispatch(getUserCashBacks({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...userCashBackDealEntity,
      ...values,
      deal: deals.find(it => it.id.toString() === values.deal?.toString()),
      userCashBack: userCashBacks.find(it => it.id.toString() === values.userCashBack?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userCashBackDealEntity,
          deal: userCashBackDealEntity?.deal?.id,
          userCashBack: userCashBackDealEntity?.userCashBack?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.userCashBackDeal.home.createOrEditLabel" data-cy="UserCashBackDealCreateUpdateHeading">
            <Translate contentKey="tycheApp.userCashBackDeal.home.createOrEditLabel">Create or edit a UserCashBackDeal</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-cash-back-deal-id"
                  label={translate('tycheApp.userCashBackDeal.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                id="user-cash-back-deal-deal"
                name="deal"
                data-cy="deal"
                label={translate('tycheApp.userCashBackDeal.deal')}
                type="select"
              >
                <option value="" key="0" />
                {deals
                  ? deals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="user-cash-back-deal-userCashBack"
                name="userCashBack"
                data-cy="userCashBack"
                label={translate('tycheApp.userCashBackDeal.userCashBack')}
                type="select"
              >
                <option value="" key="0" />
                {userCashBacks
                  ? userCashBacks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-cash-back-deal" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserCashBackDealUpdate;
